<template>
    <div class="lazy-image">
        <div class="lazy-image__placeholder">
            <div class="lazy-image__container lazy-image__container--small"
                 v-bind:style="{ 'background-image': 'url(' + srcSmall + ')'}"
                 v-bind:class="{'lazy-image__container--unload': largeLoaded, 'lazy-image__container--contain': contain,  'lazy-image__container--blur': blur}"></div>
            <div class="lazy-image__container lazy-image__container--large" v-bind:style="{ 'background-image': 'url(' + src + ')'}"
                 v-bind:class="{'lazy-image__container--loaded': largeLoaded, 'lazy-image__container--contain': contain}"></div>

        </div>
    </div>
</template>
<script>
    export default {
        props: [
            'src',
            'srcSmall',
            'contain',
            'blur'
        ],
        data () {
            return {
                smallLoaded: false,
                largeLoaded: false
            }
        },
        mounted() {
            var that = this

            // 1: load small image and show it
            var img = new Image();
            img.src = this.srcSmall;
            img.onload = function () {
                that.smallLoaded = true
            };

            // 2: load large image
            var imgLarge = new Image();
            imgLarge.src = this.src;
            imgLarge.onload = function () {
                that.smallLoaded = false
                that.largeLoaded = true
            };

        }
    }
</script>
<style lang="scss">
    .lazy-image {
        width: 100%;
        height: 100%;

        background-repeat: no-repeat;
        background-size: cover;

        overflow: hidden;

        &__placeholder {
            position: relative;

            width: 100%;
            height: 100%;
        }

        &__container {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;

            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;

            opacity: 1;

            transition: filter .5s cubic-bezier(.25, .46, .45, .94), -webkit-filter .5s cubic-bezier(.25, .46, .45, .94), opacity .5s cubic-bezier(.25, .46, .45, .94);

            &--unload {
                opacity: 0;
            }

            &--contain {
                background-size: contain;
            }

            &--blur {
                filter: blur(60px);
                &.lazy-image__container--loaded {
                    filter: blur(0);
                }
            }
        }
    }

</style>